import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { resolveEventFormOrganizationId } from './event-form-org.util';
import {
  modulesFieldEnabledOrgKey,
  EVENT_MODULES_FIELD_EVENT_TYPES,
} from './event-modules-field.util';

function isOrgSettingTrue(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * Whether the modules page (page2) and module fields are shown for the selected event_type.
 */
export function event_modules_page_visible(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_modules_page_visible',
    description:
      'Whether event modules page is shown for the current event type (events_modules_field_*_enabled org settings).',
    execute: (params?: LoadDataParams): Observable<{ visible: boolean }> => {
      const auth = service.injector.get(AuthService);
      const orgId = resolveEventFormOrganizationId(params, auth);
      const query = params?.queryParams ?? {};
      const eventType = String(query['event_type'] ?? '').trim();

      if (!eventType) {
        return of({ visible: true });
      }

      if (
        !EVENT_MODULES_FIELD_EVENT_TYPES.includes(
          eventType as (typeof EVENT_MODULES_FIELD_EVENT_TYPES)[number]
        )
      ) {
        return of({ visible: true });
      }

      if (orgId == null) {
        return of({ visible: true });
      }

      const obs = service.executeDataSource('org_settings', {
        organizationId: orgId,
      });
      if (!obs) {
        return of({ visible: true });
      }

      return obs.pipe(
        map((res: { data?: Record<string, unknown> }) => {
          const key = modulesFieldEnabledOrgKey(eventType);
          const raw = res?.data?.[key];
          if (raw === undefined || raw === null) {
            return { visible: true };
          }
          return { visible: isOrgSettingTrue(raw) };
        }),
        catchError(() => of({ visible: true }))
      );
    },
  };
}
